import { render, staticRenderFns } from "./Blocked.vue?vue&type=template&id=1fbbedb2&scoped=true&"
import script from "./Blocked.vue?vue&type=script&lang=js&"
export * from "./Blocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbbedb2",
  null
  
)

export default component.exports